/* dl-cartplus.js — design—light · cart drawer additions (2026-08-21)
   Loaded on EVERY template (snippets/dl-assets.liquid), because the drawer is
   global. Purely additive: it decorates the DOM dl-cart.js renders and drives
   dl-cart.js's own controls. Deleting this file, its stylesheet and their two
   lines in dl-assets.liquid is the entire rollback.

   -- WHY NOT JUST EDIT dl-cart.js ---------------------------------------------
   56 KB, and KOSIK_LIVE_STATE_2026-08-09 records three failed uploads across two
   sessions over a single backslash. Everything here is achievable from outside
   it, so it is not opened.

   -- FOUR THINGS ---------------------------------------------------------------
   1. VIEWPORT LOCK. dl-cart.css sizes the drawer with height:100dvh. Where a
      browser reports 100dvh taller than the visible area the drawer runs off the
      bottom and the last footer button is clipped. The cause was the bottom-pinned
      Shopify admin bar, so its height is written to --dlk-bar and subtracted
      (2026-10-24: no longer a frozen innerHeight, see lockVh).
   2. RELABEL. „Zařadit do místností" reads as an instruction, so people think
      they must. It becomes „Košík / Rozřazení místností" — names the screen and
      still advertises the feature. Matched by TEXT, not by class, so it survives
      dl-cart.js re-rendering the footer with different markup.
   3. PER-PIECE PRICE. The drawer only ever showed the line total, so a line of
      3 read as a single very expensive lamp. A „3 x 659 921 Kč" line goes under
      the total whenever quantity > 1. The unit price is read from /cart.js
      (final_price, i.e. after discounts) — NOT derived by dividing the line
      total, which would round wrong on discounted lines and is money on screen.
   4. QUANTITY DIALOG. Clicking the quantity number opens a dialog you can type
      into, instead of pressing + twenty-seven times.

   -- HOW THE QUANTITY IS ACTUALLY WRITTEN --------------------------------------
   It is NOT written with /cart/change.js. dl-cart.js holds the cart in its own
   closure (CART), and writing behind its back would leave that state stale.
   Instead the dialog synthesises clicks on the row's own +/- buttons, which
   carry the line key in data-inc / data-dec. dl-cart.js's bumpQty() accumulates
   into qpend and debounces 400 ms, so 26 synthetic clicks coalesce into ONE
   /cart/update.js — its request, its state, its re-render. Nothing here knows
   how to mutate a cart, which is the point. */

(function () {
  'use strict';

  var ROOMS_OLD = 'Zařadit do místností';
  var ROOMS_NEW = 'Košík / Rozřazení místností';
  var MAX_QTY = 999;

  /* the shared ✕ glyph — assets/dl-x.css */
  var X_IC = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="square" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>';
  var TICK_IC = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 13 4.5 4.5L19 7"></path></svg>';

  /* ---------- 1. viewport lock ---------- */

  /* Shopify's admin/preview bar is a bottom-pinned overlay (#PBarNextFrameWrapper,
     measured at 68px on this store). It paints OVER the drawer, so the last footer
     button sits behind it — which is what Hynek was seeing, and why it never
     reproduced as a layout overflow. Its height is subtracted so the drawer ends
     above it. Staff-only: customers have no bar, the offset is 0, and nothing
     changes for them. The bar is injected asynchronously, hence relock(). */
  function bottomBarHeight() {
    var ids = ['PBarNextFrameWrapper', 'preview-bar-iframe'];
    var h = 0;
    for (var i = 0; i < ids.length; i++) {
      var el = document.getElementById(ids[i]);
      if (!el) continue;
      var cs = window.getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden') continue;
      var r = el.getBoundingClientRect();
      /* only count it if it really is parked on the bottom edge */
      if (r.height > 0 && r.bottom >= window.innerHeight - 2) h = Math.max(h, r.height);
    }
    return h;
  }

  /* Only the bar's height is written; the drawer itself is sized by 100dvh in
     dl-cartplus.css (2026-10-24). It used to write innerHeight as a fixed --dlk-vh,
     which froze the drawer short whenever innerHeight was small at that moment. */
  function lockVh() {
    document.documentElement.style.setProperty('--dlk-bar', bottomBarHeight() + 'px');
  }

  /* the bar arrives after load, so re-measure a few times, then stop */
  function relock() {
    var n = 0;
    var iv = setInterval(function () {
      lockVh();
      if (++n > 10) clearInterval(iv);
    }, 400);
  }

  /* ---------- money ---------- */

  /* Shopify prices are integer minor units. cs-CZ groups with a non-breaking
     space, which is what the rest of the drawer already renders. */
  function money(minor) {
    var v = Math.round(minor) / 100;
    try {
      return v.toLocaleString('cs-CZ', { maximumFractionDigits: 0 }) + ' Kč';
    } catch (e) {
      return String(Math.round(v)) + ' Kč';
    }
  }

  /* ---------- cart data ---------- */

  var lines = {};   /* line key -> {qty, unit} */
  var fetching = false;
  var fetchedAt = 0;

  function refresh(force) {
    var now = (window.performance && performance.now) ? performance.now() : 0;
    if (fetching) return;
    if (!force && fetchedAt && (now - fetchedAt) < 1500) return;
    fetching = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var map = {};
        (c.items || []).forEach(function (i) {
          map[i.key] = { qty: i.quantity, unit: i.final_price, title: i.product_title || '' };
        });
        lines = map;
        fetchedAt = (window.performance && performance.now) ? performance.now() : 0;
        fetching = false;
        decorate();
      }, function () { fetching = false; });
  }

  function keyOf(row) {
    var b = row.querySelector('[data-inc]') || row.querySelector('[data-dec]');
    if (!b) return '';
    return b.getAttribute('data-inc') || b.getAttribute('data-dec') || '';
  }

  /* ---------- 2 + 3 + 4: decorate whatever is on screen ---------- */

  function relabel(root) {
    var els = root.querySelectorAll('button, a');
    for (var i = 0; i < els.length; i++) {
      if (els[i].textContent.trim() === ROOMS_OLD) els[i].textContent = ROOMS_NEW;
    }
  }

  function decorate() {
    var root = document.querySelector('.dlk-dwr');
    if (!root) return;

    relabel(root);

    var rows = root.querySelectorAll('.dl');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var key = keyOf(row);
      var num = row.querySelector('.qty span');
      var end = row.querySelector('.end');
      if (!num || !end) continue;

      /* make the number a control (idempotent) */
      if (!num.hasAttribute('data-dlcp-qty')) {
        num.setAttribute('data-dlcp-qty', '');
        num.setAttribute('role', 'button');
        num.setAttribute('tabindex', '0');
        num.setAttribute('aria-haspopup', 'dialog');
        num.setAttribute('title', 'Zadat počet kusů');
      }

      /* per-piece line, only above quantity 1 */
      var rec = lines[key];
      var qty = rec ? rec.qty : parseInt(num.textContent, 10);
      var old = end.querySelector('.dlcp-unit');
      if (rec && qty > 1) {
        var txt = qty + ' × ' + money(rec.unit);
        if (!old) {
          old = document.createElement('span');
          old.className = 'dlcp-unit';
          var b = end.querySelector('b');
          if (b && b.nextSibling) end.insertBefore(old, b.nextSibling);
          else end.appendChild(old);
        }
        if (old.textContent !== txt) old.textContent = txt;
      } else if (old) {
        old.parentNode.removeChild(old);
      }
    }
  }

  /* ---------- quantity dialog ---------- */

  var box = null;
  var lastFocus = null;

  function closeQd() {
    if (!box) return;
    var el = box;
    box = null;
    document.removeEventListener('keydown', onKey, true);
    if (el.parentNode) el.parentNode.removeChild(el);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
    lastFocus = null;
  }

  function onKey(e) {
    if (e.key === 'Escape' || e.keyCode === 27) { e.stopPropagation(); closeQd(); }
  }

  /* Drives dl-cart.js's own stepper. See the header: N synchronous clicks land
     inside one debounce window and become a single /cart/update.js. */
  function applyQty(row, current, target) {
    var delta = target - current;
    if (!delta) return;
    var sel = delta > 0 ? '[data-inc]' : '[data-dec]';
    var btn = row.querySelector('.qty ' + sel);
    if (!btn) return;
    var n = Math.min(Math.abs(delta), MAX_QTY + 1);
    for (var i = 0; i < n; i++) btn.click();
    /* dl-cart.js's optimistic repaint targets [data-key], which the drawer rows
       do not carry, so the number would sit stale until the re-render lands.
       Paint it here so the click feels immediate. */
    var num = row.querySelector('.qty span');
    if (num) num.textContent = String(target);
    setTimeout(function () { refresh(true); }, 900);
  }

  function openQd(row) {
    closeQd();
    lastFocus = document.activeElement;

    var key = keyOf(row);
    var rec = lines[key];
    var num = row.querySelector('.qty span');
    var current = rec ? rec.qty : (parseInt(num && num.textContent, 10) || 1);
    var unit = rec ? rec.unit : 0;
    var name = (row.querySelector('.nm') || {}).textContent || '';
    var variant = (row.querySelector('.vr') || {}).textContent || '';

    var el = document.createElement('div');
    el.className = 'dlqd';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Počet kusů');
    el.addEventListener('click', function (ev) { if (ev.target === el) closeQd(); });

    var panel = document.createElement('div');
    panel.className = 'dlqd-panel';

    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'dlqd-x dl-x';
    x.setAttribute('aria-label', 'Zavřít');
    x.innerHTML = X_IC;
    x.addEventListener('click', closeQd);

    var eye = document.createElement('span');
    eye.className = 'dlqd-eyebrow';
    eye.textContent = 'Počet kusů';

    var h = document.createElement('h2');
    h.className = 'dlqd-t';
    h.textContent = name.trim() || 'Položka';

    var sub = document.createElement('p');
    sub.className = 'dlqd-sub';
    sub.textContent = variant.trim();

    var rowEl = document.createElement('div');
    rowEl.className = 'dlqd-row';

    var minus = document.createElement('button');
    minus.type = 'button';
    minus.className = 'dlqd-step';
    minus.setAttribute('aria-label', 'Méně');
    minus.textContent = '−';

    var input = document.createElement('input');
    input.className = 'dlqd-n';
    input.type = 'number';
    input.min = '0';
    input.max = String(MAX_QTY);
    input.step = '1';
    input.value = String(current);
    input.setAttribute('aria-label', 'Počet kusů');
    input.setAttribute('inputmode', 'numeric');

    var plus = document.createElement('button');
    plus.type = 'button';
    plus.className = 'dlqd-step';
    plus.setAttribute('aria-label', 'Více');
    plus.textContent = '+';

    var total = document.createElement('div');
    total.className = 'dlqd-total';

    var ok = document.createElement('button');
    ok.type = 'button';
    ok.className = 'dlqd-ok';

    function val() {
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 0) v = 0;
      if (v > MAX_QTY) v = MAX_QTY;
      return v;
    }

    function sync() {
      var v = val();
      if (v === 0) {
        total.innerHTML = '';
        ok.className = 'dlqd-ok danger';
        ok.innerHTML = TICK_IC + '<span>Odebrat z košíku</span>';
      } else {
        total.innerHTML = unit
          ? (v + ' × ' + money(unit) + ' = <b>' + money(unit * v) + '</b>')
          : '';
        ok.className = 'dlqd-ok';
        ok.innerHTML = TICK_IC + '<span>Uložit</span>';
      }
    }

    function bump(d) {
      input.value = String(Math.max(0, Math.min(MAX_QTY, val() + d)));
      sync();
    }

    minus.addEventListener('click', function () { bump(-1); });
    plus.addEventListener('click', function () { bump(1); });
    input.addEventListener('input', sync);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); commit(); }
    });

    function commit() {
      var v = val();
      closeQd();
      applyQty(row, current, v);
    }

    ok.addEventListener('click', commit);

    rowEl.appendChild(minus);
    rowEl.appendChild(input);
    rowEl.appendChild(plus);

    panel.appendChild(x);
    panel.appendChild(eye);
    panel.appendChild(h);
    if (variant.trim()) panel.appendChild(sub);
    panel.appendChild(rowEl);
    panel.appendChild(total);
    panel.appendChild(ok);
    el.appendChild(panel);
    document.body.appendChild(el);
    box = el;
    sync();

    document.addEventListener('keydown', onKey, true);
    setTimeout(function () { try { input.focus(); input.select(); } catch (e) {} }, 50);
  }

  /* ---------- wiring ---------- */

  /* Delegated, so it keeps working across every re-render of the drawer. */
  function onDocClick(e) {
    var n = e.target.closest ? e.target.closest('[data-dlcp-qty]') : null;
    if (!n) return;
    var row = n.closest('.dl');
    if (!row) return;
    e.preventDefault();
    e.stopPropagation();
    openQd(row);
  }

  function onDocKey(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var n = e.target.closest ? e.target.closest('[data-dlcp-qty]') : null;
    if (!n) return;
    var row = n.closest('.dl');
    if (!row) return;
    e.preventDefault();
    openQd(row);
  }

  function boot() {
    lockVh();
    relock();
    window.addEventListener('resize', lockVh);
    window.addEventListener('orientationchange', lockVh);

    document.addEventListener('click', onDocClick, true);
    document.addEventListener('keydown', onDocKey, true);

    refresh(true);
    decorate();

    if (!window.MutationObserver) return;
    var t = 0;
    var obs = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { decorate(); refresh(false); }, 60);
    });
    /* Observe the drawer, not the whole body: dl-cart.js re-renders it often and
       the rest of the page is none of our business. decorate() is idempotent, so
       the mutations it makes itself settle on the next pass instead of looping. */
    var drawer = document.querySelector('.dlk-dwr');
    if (drawer) obs.observe(drawer, { childList: true, subtree: true });
    else obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
